export class GroupByHelper {

    static groupBy(collection: any[], callback: (value: any) => string): any[] {
        return collection.reduce(
            (agg, current) => ({
                ...agg,
                [callback(current)]: [
                    ...(agg[callback(current)] || []),
                    current
                ]
            }),
            {}
        );
    }

    static getUniqueValues(collection: any[]) {
        return Object.keys(collection).map(key => {
            return collection[key][0];
        });
    }
}